import React from 'react';
import Modal from '@carvana/showroom-modal';
import {
  ModalContent,
  ModalMessage,
  SupportMessage,
  SadCarImage,
  HyperLink,
} from './OopsError.styles';
import { currentAssetsUrl } from '../../../utils/baseUrlUtil';

const OopsError = (props: { isOpen: any; closeModal: any }) => {
  const { isOpen, closeModal } = props;

  return (
    <Modal
      className="oopsError"
      headerText="OOPS, SOMETHING WENT WRONG"
      closeModal={closeModal}
      isOpen={isOpen}
      testHook="test-modal"
      mode="light"
      portalDivId="shaun-test"
    >
      <ModalContent>
        <SadCarImage
          src={`${currentAssetsUrl(
            process.env.NODE_ENV
          )}/op-assets/my-cars/SadCar.png`}
        />
        OOPS, SORRY!
        <ModalMessage>
          We&apos;re having trouble accessing your loan account. We&apos;re
          sorry for the inconvenience.
        </ModalMessage>
        <SupportMessage>
          Please call Bridgecrest support at:{' '}
          <HyperLink href="tel:8009678526" type="external">800-967-8526</HyperLink>
          <br />
          Or manage at:{' '}
          <HyperLink href="www.bridgecrest.com" target="_blank" type="external">
            www.bridgecrest.com
          </HyperLink>
        </SupportMessage>
      </ModalContent>
    </Modal>
  );
};

export default OopsError;
